import { Currency } from '@/core/currency/interfaces';

const WST: Currency = {
    name: 'Samoan Tala',
    demonym: 'Samoan',
    majorSingle: 'Tala',
    majorPlural: 'Tala',
    codeNumeric: '882',
    symbol: 'T',
    symbolNative: 'ST',
    minorSingle: 'Sene',
    minorPlural: 'Sene',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'WST',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default WST;
